module.exports = __webpack_public_path__ + "static/media/result_rb_ja.90dc3221.jpg";